import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/data/estates'
export default {
  namespaced: true,
  state: {
    dataList: [],
    dataCounts: 0,
    dataItem: {
      id: null,
      ecode: null,
      title: null,
      notes: null,
      address: null,
      status: '1',
      id_cities: null,
      id_districts: null,
      tenants: {
        id: null,
        tenant_code: null,
        title: null,
        phone: null,
        sdate: null,
        edate: null,
        amount: null,
        notes: null,
        created: null,
      },
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    tenantModal: {
      status: false,
      type: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    tenantModal(state) {
      return state.tenantModal
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        ecode: null,
        title: null,
        notes: null,
        address: null,
        status: '1',
        id_cities: null,
        id_districts: null,
        tenants: {
          id: null,
          tenant_code: null,
          title: null,
          phone: null,
          sdate: null,
          edate: null,
          amount: null,
          notes: null,
          created: null,
        },
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
        })
        .catch(error => console.error(error))
    },
    getDataItem({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'estates.id': id,
        },
        array: false,
      })
      return axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_ITEM', response.data.data)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    saveData({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post(`${ROOT_URL}/saveData`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    removeData({ commit }, id) {
      axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
    tenantUpdate({ commit }, data) {
      return axiosIns.post(`${ROOT_URL}/tenantUpdate`, data)
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
